import { useCallback } from 'react';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';

export function useNotifications() {
  
  const requestPermission = useCallback(async () => {
    if (Capacitor.isNativePlatform()) {
      const result = await LocalNotifications.requestPermissions();
      return result.display === 'granted';
    } else {
      if (!('Notification' in window)) return false;
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }
  }, []);

  const sendNotification = useCallback(async (title: string, options?: { body?: string, id?: number }) => {
    if (Capacitor.isNativePlatform()) {
      await LocalNotifications.schedule({
        notifications: [
          {
            title,
            body: options?.body || '',
            id: options?.id || Math.floor(Math.random() * 100000),
            schedule: { at: new Date(Date.now() + 100) }, // Schedule immediately
            sound: 'default',
            actionTypeId: '',
            extra: null
          }
        ]
      });
    } else {
      if (!('Notification' in window)) {
        console.warn('This browser does not support desktop notifications');
        return;
      }

      if (Notification.permission === 'granted') {
        new Notification(title, {
          icon: '/pwa-192x192.png',
          body: options?.body,
        });
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                new Notification(title, {
                    icon: '/pwa-192x192.png',
                    body: options?.body,
                });
            }
        });
      }
    }
  }, []);

  return { sendNotification, requestPermission };
}
